import { useState } from "react";
import { Dialog, DialogTitle, IconButton, TextField, Tooltip, Typography } from "@mui/material";
import { DialogActionsBar } from "@progress/kendo-react-dialogs";
import CloseIcon from '@mui/icons-material/Close';

import { LoadingIndicator } from "../../components/loading-indicator.component";
import { useAuthorize } from "../../hooks/use-authorize";
import { UserPermissionName } from "../../models/user-permission-name";

interface ReasonDialogComponent {
    isOpenReason: boolean;
    isLoading: boolean;
    onSubmit: (reason: string) => void;
    onClosed: () => void;
}
export const ReasonDialogComponent = ({ isOpenReason, isLoading, onSubmit, onClosed }: ReasonDialogComponent) => {

    const [reason, setReason] = useState<string>('');
    const [reasonError, setReasonError] = useState<boolean>(false);

    const handleSaveReasonClick = async () => {
        if (!reason.trim()) {
            setReasonError(true);
            return;
        }
        onSubmit(reason);
    };

    const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

    return (
        <Dialog
            open={isOpenReason}
            className="modalpopup"
            title={'REASON'}
            // onClose={onClosed}
            maxWidth={'md'}
            fullWidth={true}
        >
            <DialogTitle id="alert-dialog-title" sx={{ p: 2, pt: 1, pb: 1, m: 0 }}>
                Reason
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClosed}
                sx={{
                    position: 'absolute',
                    right: 10,
                    top: 3,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <Tooltip title={<Typography variant="body1">Close</Typography>}>
                    <CloseIcon />
                </Tooltip>
            </IconButton>
            <div style={{ padding: '15px 30px' }}>
                <TextField
                    id="reason"
                    label="Reason for decline"
                    multiline
                    rows={4}
                    variant="outlined"
                    value={reason}
                    onChange={(e: any) => {
                        setReason(e.target.value);
                        setReasonError(false);
                    }}
                    error={reasonError}
                    helperText={reasonError ? 'Reason is required' : ''}
                    fullWidth
                    margin="normal"
                />
            </div>
            {isLoading && <LoadingIndicator isLoading={isLoading} />}
            <DialogActionsBar>
                <div className=" spaceBetween">
                    <button
                        style={{ cursor: 'pointer' }}
                        className="btn btn-sm btn-default btn-lightGrey"
                        onClick={onClosed}
                        autoFocus
                    >
                        Cancel
                    </button>
                    <button
                        className="btn btn-sm btn-primary  btn-delete"
                        style={{
                            backgroundColor: isReadOnlyPermission ? '#d7dbdd' : '#0000b5',
                            color: isReadOnlyPermission ? 'black' : '#fff',
                            cursor: 'pointer'
                        }}
                        type="button"
                        onClick={handleSaveReasonClick}
                        disabled={isLoading || isReadOnlyPermission}
                    >
                        Save
                    </button>
                </div>
            </DialogActionsBar>
        </Dialog>
    );
}